import { primitives } from './generated/tokens.generated';

/**
 * `theme.color` is sourced from the generated (Figma-derived) primitives — the CI drift
 * gate keeps it aligned with the "Kickfin - Design System" file. Do not hand-edit values;
 * change the Figma exports and run `yarn tokens:build`.
 *
 * Status colors (success/warning/danger/cash) and info are keyed 25/50/100.
 */

/**
 * Shade shapes are derived from the generated primitives, not hand-listed — so a shade
 * added in Figma flows into these types automatically, keeping the "drift is a compile
 * error" guarantee for added keys, not just changed values.
 * (Type aliases rather than interfaces because they're mapped from the generated type.)
 */
export type IColorShades = Record<keyof typeof primitives.color.primary, string>;
export type IColorStatusShades = Record<keyof typeof primitives.color.info, string>;

export interface IColors {
  primary: IColorShades;
  secondary: IColorShades;
  neutral: IColorShades;
  info: IColorStatusShades;
  success: IColorStatusShades;
  warning: IColorStatusShades;
  danger: IColorStatusShades;
  cash: IColorStatusShades;
  white: string;
}

export const Colors: IColors = {
  primary: primitives.color.primary,
  secondary: primitives.color.secondary,
  neutral: primitives.color.neutral,
  info: primitives.color.info,
  success: primitives.color.success,
  warning: primitives.color.warning,
  danger: primitives.color.danger,
  cash: primitives.color.cash,
  // Figma exports white as a single-shade group, so unwrap its one key (`25`) to a plain string.
  white: primitives.color.white[25],
};
